import { useState, useRef, useEffect } from 'react'

interface ContainerDimensions {
  width: number
  height: number
}

export const useContainerDimensions = (): [React.RefObject<HTMLDivElement>, ContainerDimensions] => {
  const containerRef = useRef<HTMLDivElement>(null as unknown as HTMLDivElement)
  const [dimensions, setDimensions] = useState<ContainerDimensions>({ width: 0, height: 0 })

  useEffect(() => {
    const updateDimensions = () => {
      if (containerRef.current) {
        const { clientWidth, clientHeight } = containerRef.current
        setDimensions({
          width: Math.max(clientWidth, 300), // Minimum width
          height: Math.max(clientHeight, 300) // Minimum height
        })
      }
    }

    updateDimensions()

    const resizeObserver = new ResizeObserver(updateDimensions)
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current)
    }

    return () => {
      resizeObserver.disconnect()
    }
  }, [])

  return [containerRef, dimensions]
}